<template>
    <div class="form-container">
        <div role="alert" class="row alert status-box alert-danger" v-show="error">
            <div class="col media"  style="padding: 10px;">
                <div class="d-flex mr-2 status-icon" style="margin-top: 3px;">
                    <i class="fa fa-exclamation-circle"></i>
                </div>
                <div class="media-body">
                    {{error}}
                    <i class="fa fa-remove" style="float:right;margin-top: 3px;" @click="error=false" ></i>
                </div>
            </div>
        </div>
        <div>

            <div class="row">
                <div class="col-4">First Name</div>
                <div class="col-8"><input type="text" class="form-control" v-model="form.first" /> </div>
            </div>
            <div class="row">
                <div class="col-4">Last Name</div>
                <div class="col-8"><input type="text" class="form-control" v-model="form.last" /> </div>
            </div>

            <div class="row">
                <div class="col-4">Company Name</div>
                <div class="col-8"><input type="text" class="form-control" v-model="form.company_name" /> </div>
            </div>

            <div class="row">
                <div class="col-4">Company Address</div>
                <div class="col-8">
                    <google-address-searcher :selected="form.address.formatted_address" v-model="form.address"></google-address-searcher>
                </div>
            </div>

            <div class="row">
                <div class="col-4">Email</div>
                <div class="col-8"><input type="text" class="form-control" v-model="form.email"/> </div>

            </div>


            <br />
            <br />
            <div class="row heading">
                <div class="col">
                    <h2>Commissions</h2>
                </div>
            </div>


            <div class="row">

                <label class="col-5 col-sm-7  col-md-3 col-lg-2 col-form-label">Tier 1 Comms</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">

                    <div class="input-group">
                        <input type="text" class="form-control" v-model="form.tier1_commsrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>

                <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label">Tier 1 Spiff</label>

                <div class="col-7 col-sm-5 col-md-3 col-lg-2">
                    <div class="input-group" >
                        <input type="text" class="form-control" v-model="form.tier1_spiffrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>


                <div class="w-100"></div>

                <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-form-label">Tier 2 Comms</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">
                    <div class="input-group" >
                        <input type="text" class="form-control" v-model="form.tier2_commsrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
                <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label">Tier 2 Spiff</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">

                    <div class="input-group" >
                        <input type="text" class="form-control" v-model="form.tier2_spiffrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
                <div class="w-100"></div>



                <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-form-label">Tier 3 Comms</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">
                    <div class="input-group"  >
                        <input type="text" class="form-control" v-model="form.tier3_commsrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
                <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label">Tier 3 Spiff</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">

                    <div class="input-group" >
                        <input type="text" class="form-control" v-model="form.tier3_spiffrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
                <div class="w-100"></div>



                <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-form-label">Tier 4 Comms</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">
                    <div class="input-group" >
                        <input type="text" class="form-control" v-model="form.tier4_commsrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
                <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2  offset-lg-2 col-form-label">Tier 4 Spiff</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">

                    <div class="input-group">
                        <input type="text" class="form-control" v-model="form.tier4_spiffrate" />
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
                <div class="w-100"></div>

            </div>


            <br />
            <br />


            <div class="row heading">
                <div class="col">
                    <h2>Exception</h2>
                </div>
            </div>

            <div class="row">
                <label class="col-5 col-sm-7  col-md-3 col-lg-2 col-form-label">Agent</label>
                <div class="col-7 col-sm-5 col-md-5 col-lg-4">
                    <auto-complete
                            placeholder="Choose Agent"
                            :list="agentNames"
                            :selection="exception_name"
                            @change="setExceptionAgent"
                            @input="fetchAgents"

                    >
                    </auto-complete>
                </div>
            </div>

            <div class="row">
                <label class="col-5 col-sm-7  col-md-3 col-lg-2 col-form-label">Comms </label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="form.exception_commsrate">
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <label class="col-5 col-sm-7  col-md-3 col-lg-2 col-form-label">Spiff</label>
                <div class="col-7 col-sm-5 col-md-3 col-lg-2">
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="form.exception_spiffrate">
                        <div class="input-group-addon">
                            %
                        </div>
                    </div>
                </div>
            </div>



         </div>
        <div class="modal-footer">
            <button class="btn btn-clear" @click="$emit('close');" >Cancel</button>
            <button @click="saveAgent" class="btn btn-primary">Save New Agent</button>
        </div>

    </div>

</template>
<script type="text/babel">
    import AutoComplete  from '../assets/Autocomplete.vue';
    import Dropdown from '../assets/Dropdown.vue';
    import AgentCommissions from './AgentCommissions.vue';
    import GoogleAddressSearcher from '../assets/GoogleAddressSearcher.vue';

    export default {
        name: 'AddAgent',
        data: function(){
            return {
                id: '',

                exception_name: '',
                form:{
                    user_id: '',
                    first: '',
                    last: '',
                    company: '',
                    company_name: '',
                    email: '',

                    tier1_commsrate:'25',
                    tier1_spiffrate: '25',
                    tier2_commsrate:'40',
                    tier2_spiffrate: '40',
                    tier3_commsrate:'60',
                    tier3_spiffrate: '60',
                    tier4_commsrate:'70',
                    tier4_spiffrate: '70',

                    exception_user_id: '',
                    exception_commsrate: '5',
                    exception_spiffrate: '5',

                    address: {
                        address:'' ,
                        formatted_address: ''
                    }
                },
                agentProfile:{
                    username: null,
                    name: null,
                    Abcomm: null,
                    telno:null,
                    sandler_username:null,
                    sandler_password:null,
                    sandler_id:null,
                    email: null,
                    channel_id: null,
                    channel_name: null,
                    is_channel: false
                },
                statuses: [],
                agents:[],
                channels: [],
                channel:{},
                error: false,

            }
        },
        beforeCreate(){

        },
        components:{
            Dropdown,
            AutoComplete,
            AgentCommissions,
            GoogleAddressSearcher
        },
        created(){

            this.fetchAgents();

        },
        computed:{
            agentNames(){
                if(!this.agents) return [];
                return this.agents.map(function(agent){
                    return agent.name;
                })
            },



        },
        filters:{
            formatDate(date){
                if(!date) return null;
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            }
        },
        props: {
            stay: {
                type: Boolean,
                default: false
            },
            account_id:{
                type: String,
                required: false
            }
        },
        methods:{

            fetchAgents(search){
                this.exception_name = search;
                this.$send(this, 'userUsers',{
                    search: search
                }).then(r => {
                    this.agents = r.userUsers;
                });
            },

            getAgentName(u){
                var agent_id = u.user_id;
                var username = this.agents.filter(function(agent){
                    return agent.user_id == agent_id;
                }).map(function(agent){
                    return agent.name;
                });

                if(username.length) return username[0];
                return '';

            },
            setExceptionAgent(name){
                this.form.exception_user_id = this.agents.filter(function(c){
                    return c.name == name;
                }).map(function(c){
                    return c.user_id;
                })[0];

                if(this.form.exception_user_id){
                    this.exception_name = name;

                } else {
                    this.exception_name = '';
                }
            },

            setReferrer(channelName){

                this.form.referrer_id = this.agents.filter(function(c){
                    return c.name == channelName;
                }).map(function(c){
                    return c.user_id;
                })[0];

                if(this.form.referrer_id){
                    this.form.referrer_name = channelName;

                } else {
                    this.form.referrer_name = '';
                }
            },



            fetchChannels(){
                this.$send(this, 'channels').then(r => {
                    this.channels = r.channels;
                });
            },

            fetchProfile(id){

                this.$send(this, 'userProfile',{
                    user_id: id
                }).then(r => {
                    this.agentProfile = r.userProfile;
                    this.form.user_id = id;
                });
            },
            saveAgent(){

                this.error = false;

                this.form.name = this.form.username;
                if(this.error) return;

                if(this.account_id) this.form.account_id = this.account_id;

                this.$send(this, 'userCreate', this.form).then(r => {
                    if(!r.error){
                        this.id = r.userCreate.user_id;
                        this.finish(r.userCreate);
                    } else {
                        this.error = r.error;
                    }

                });

            },
            finish(agent){

                if(this.stay === true){
                    this.$emit('close');
                    this.$emit('saved', agent);
                } else {

                    this.$router.push('agents/' + this.id);
                }


            },
        },

    }
</script>



// WEBPACK FOOTER //
// AddAgent.vue?bd9a483a